import {textInProfileFields} from './textInProfileFields';

/**
 * Matches the participant text against the given regular expression.
 *
 * @param {object} p - The participant object containing first_name, last_name, company, position, and description fields.
 * @param {RegExp} exp - The regular expression to match against.
 * @return {boolean} Returns true if any of the participant fields or profile fields match the regular expression, otherwise false.
 */
export function matchParticipantText(p, exp) {
    if (!p || !exp) return false;

    return !!(
        p.first_name?.match(exp) ||
        p.last_name?.match(exp) ||
        p.company?.match(exp) ||
        p.position?.match(exp) ||
        p.description?.match(exp) ||
        p.email?.match(exp) ||
        p.user_email?.match(exp) ||
        p.external_id?.match(exp) ||
        textInProfileFields(p, exp)
    );
}
